// import AnimationController from '../../../assets/js/controllers/animation';

import { classesActiveAndIn } from '../../../assets/js/helpers';

export default class GridPartners {

	static selector = 'grid-partners';

	// class variables

	config = {
		animations: {
			out: {
				duration: 600
			}
		}
	};

	el = {};

	timeouts = {
		transitionOut: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			contentWrapper: container.querySelector(`.${this.constructor.selector}__content-wrapper`),
			ctaMore: container.querySelector(`.${this.constructor.selector}__cta-more`),
			items: container.querySelectorAll(`.${this.constructor.selector}__grid-item`)
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.el.contentWrapper.classList.add(`item-count--${this.el.items.length}`);
		this.#addEventListeners();
	}

	// add and remove listeners

	#addEventListeners = () => {
		if (this.el.ctaMore) {
			this.el.ctaMore.addEventListener('click', this.#onCtaMoreClick);
		}
	}

	#removeEventListeners = () => {
		if (this.el.ctaMore) {
			this.el.ctaMore.removeEventListener('click', this.#onCtaMoreClick);
		}
	}

	// listener methods

	#onCtaMoreClick = (e) => {
		e.preventDefault();
		this.el.contentWrapper.classList.add('is-expanded');
		for (let i = 0; i < this.el.items.length; i++) {
			const $item = this.el.items[i];
			if (!$item.classList.contains('is-visible')) {
				classesActiveAndIn($item, 'is-visible');
			}
		}
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
